import { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../Input";
import DataTable from "../table/DataTable";
import CashVaultDetailsModal from "./CashVaultDetailsModal";
import CreateCashVaultTransactionModal from "./CreateCashVaultTransactionModal";
import { cashVaultMockData } from "./mockData";

const CashVaultManagementList = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    type: null,
  });

  const [displayData, setDisplayData] = useState(cashVaultMockData);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleSearch = () => {
    let filtered = cashVaultMockData.filter((item) => {
      const matchStart = !filters.startDate || item.date >= filters.startDate;
      const matchEnd = !filters.endDate || item.date <= filters.endDate;
      const matchType = !filters.type || item.typeValue === filters.type.value;
      return matchStart && matchEnd && matchType;
    });
    setDisplayData(filtered);
  };

  const handleReset = () => {
    setFilters({
      startDate: "",
      endDate: "",
      type: null,
    });
    setDisplayData(cashVaultMockData);
  };

  const columns = [
    { label: "ID", key: "id", className: "ps-4", style: { width: "80px" } },
    {
      label: "Date Time",
      key: "dateTime",
      render: (item) => {
        const [date, time] = item.dateTime.split(" ");
        return (
          <div className="fs-12">
            <div className="fw-medium text-black">{date}</div>
            <div className="text-muted">{time}</div>
          </div>
        );
      },
    },
    {
      label: "Type",
      key: "type",
      render: (item) => {
        if (item.typeValue === "withdraw") {
          return (
            <Badge
              className="px-3 py-1 border rounded-pill text-white fw-bold"
              style={{
                backgroundColor: "#E50F38",
                fontSize: "11px",
                borderColor: "#E50F38",
              }}
            >
              {item.type}
            </Badge>
          );
        } else {
          return (
            <Badge
              bg="white"
              className="px-3 py-1 border rounded-pill text-black fw-bold shadow-sm"
              style={{ fontSize: "11px", borderColor: "#E2E8F0" }}
            >
              {item.type}
            </Badge>
          );
        }
      },
    },
    {
      label: "Amount",
      key: "amount",
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.amount} SGD</span>
      ),
    },
    {
      label: "Created By",
      key: "createdBy",
      render: (item) => (
        <span className="text-muted fs-13">{item.createdBy}</span>
      ),
    },
    {
      label: "Actions",
      key: "actions",
      className: "pe-4 text-center",
      render: (item) => (
        <button
          className="btn btn-xs p-0 border-0 bg-transparent text-muted"
          onClick={() => {
            setSelectedTransaction(item);
            setShowViewModal(true);
          }}
        >
          <i className="far fa-eye fs-14"></i>
        </button>
      ),
    },
  ];

  const typeOptions = [
    { label: "Deposit Cash", value: "deposit" },
    { label: "Withdraw Cash", value: "withdraw" },
  ];

  return (
    <div className="container-fluid">
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
        <h2 className="fw-bold text-black mb-0 fs-24">Cash Vault Management</h2>
        <div className="d-flex align-items-center">
          <CommonButton
            className="px-4 fw-bold text-white"
            onClick={() => setShowCreateModal(true)}
          >
            Create Transaction
          </CommonButton>
        </div>
      </div>
      <div className="card mb-4" style={{ borderRadius: "10px" }}>
        <div className="card-body p-3">
          <Row className="g-2 align-items-center">
            <Col xl={2} lg={4} md={6}>
              <CommonInput
                type="date"
                placeholder="mm / dd / yyyy"
                value={filters.startDate}
                onChange={(e) =>
                  handleFilterChange("startDate", e.target.value)
                }
              />
            </Col>
            <Col xl={2} lg={4} md={6}>
              <CommonInput
                type="date"
                placeholder="mm / dd / yyyy"
                value={filters.endDate}
                onChange={(e) => handleFilterChange("endDate", e.target.value)}
              />
            </Col>
            <Col xl={2} lg={4} md={6}>
              <CommonSelect
                placeholder="Type"
                options={typeOptions}
                value={filters.type}
                onChange={(val) => handleFilterChange("type", val)}
              />
            </Col>
            <Col md="auto" className="d-flex gap-2">
              <CommonButton
                onClick={handleReset}
                variant="outline"
                className="bg-white border text-black"
              >
                <i className="flaticon-381-repeat-1 text-black"></i>
              </CommonButton>
              <CommonButton onClick={handleSearch} className="text-white">
                <i className="flaticon-381-search-1 fs-18 text-white"></i>
              </CommonButton>
            </Col>
          </Row>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={displayData}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>

      <CashVaultDetailsModal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        transaction={selectedTransaction}
      />

      <CreateCashVaultTransactionModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
      />
    </div>
  );
};

export default CashVaultManagementList;
